import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { ResponsiveBannerComponent } from './responsive-banner.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    I18nModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoResponsiveBannerComponent: {
          component: ResponsiveBannerComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        SimpleResponsiveBannerComponent: {
          component: ResponsiveBannerComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        ShimanoMyAccountResponsiveBannerComponent: {
          component: ResponsiveBannerComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        ForgotPasswordLeftContentBannerImageComponent: {
          component: ResponsiveBannerComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    ResponsiveBannerComponent,
  ],
})
export class ResponsiveBannerModule {}
